import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/id-card': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M528 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H528C554.5 480 576 458.5 576 432V80C576 53.5 554.5 32 528 32zM528 432H303.2C304.1 427.5 304 435.6 304 409.6 304 377.8 273.9 352 236.8 352 226 352 218.1 360 192 360 165.1 360 158.6 352 147.2 352 110.1 352 80 377.8 80 409.6 80 435.6 79.8 427.5 80.8 432H48V144H528V432zM360 352H472C476.4 352 480 348.4 480 344V328C480 323.6 476.4 320 472 320H360C355.6 320 352 323.6 352 328V344C352 348.4 355.6 352 360 352zM360 288H472C476.4 288 480 284.4 480 280V264C480 259.6 476.4 256 472 256H360C355.6 256 352 259.6 352 264V280C352 284.4 355.6 288 360 288zM360 224H472C476.4 224 480 220.4 480 216V200C480 195.6 476.4 192 472 192H360C355.6 192 352 195.6 352 200V216C352 220.4 355.6 224 360 224zM192 320C227.3 320 256 291.3 256 256S227.3 192 192 192 128 220.7 128 256 156.7 320 192 320z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/id-card.js
// module id = tRQw
// module chunks = 144